import { upnlBasisEnum } from '@flipster/features/src/shared/upnl-basis/state';
import type { ChartPriceType } from '@flipster/tvchart/src/misc/chart-price-type';

/**
 * PiP pins all displayed prices and unrealized P&L to a single source, independent of the user's
 * global chart price type and uPnL basis settings.
 *
 * ROLLBACK(last-price): MM 준비 완료 시 재활성화 — 원본: Last 고정 (`upnlBasisEnum.last` / `'LAST'`).
 * MM 미준비로 mid/BBO 기준으로 임시 회귀.
 *
 * @see https://prextech.slack.com/archives/C0AQX0CL77F/p1782898653740189
 */
// export const pipUpnlBasis = upnlBasisEnum.last;
// export const pipChartPriceType: ChartPriceType = 'LAST';
export const pipUpnlBasis = upnlBasisEnum.bbo;
export const pipChartPriceType: ChartPriceType = 'MID';
